import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationPropertyConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationProperty";
    static FUNCTION_SET_OBJECTION = "SetObjection";
    static FUNCTION_SET_APPEAL = "SetAppeal";
    static FUNCTION_SET_OWNERS = "SetOwners";
    static FUNCTION_SET_PARENT_PROPERTY = "SetParentProperty";
    static FUNCTION_REMOVE_PARENT_PROPERTY = "RemoveParentProperty";
}
